module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "stepup",
    staticClass: "wwf-content"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title.toUpperCase()))]), _vm._v(" "), _c('button', {
    staticClass: "popup-close-button",
    attrs: {
      "data-close": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.handleClose()
      }
    }
  }, [_c('span', {
    staticClass: "popup-close-button-span"
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "threatened-species-popup-content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ls-ty-share"
  }, [_c('p', [_vm._v("Share")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gs-wrapper"
  }, [_c('div', {
    staticClass: "getsocial gs-inline-group"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c165e84","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/threatened-species/form-components/ThankYouPopup.vue
// module id = 775
// module chunks = 0